const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_uMKqEppkU',
  aws_user_pools_web_client_id: '3109qs6qo0jb6kctokgn1oood0',
  aws_appsync_dangerously_connect_to_http_endpoint_for_testing: false,
};

export default awsmobile;
